// extracted by mini-css-extract-plugin
export var infoItem = "_t2-2";
export var title = "_t2-0";
export var value = "_t2-1";